import { ReloadOutlined } from '@ant-design/icons';
import { Button, Image, Skeleton } from 'antd';
import API from 'API';
import GauLeft from 'components/GauLeft';
import GauQuizzes from 'components/GauQuizzes'
import React, { useMemo, useState } from 'react'

const gauMessages = [
    "Ngoài việc học hỏi các kiến thức mới từ con người",
    "Tớ còn có thể giúp cậu nhiều việc lắm đấy",
    "Như tạo cho cậu một bức tranh thật đẹp",
    "Cùng làm với tớ nhé!",
]

const prompt = `{{color}} crayon drawing by a child,
simple kindergarten drawing,
of {{animal}} {{action}} {{place}},
{{special}},
cute, simple, white background
`;

const messageString = "Cậu muốn vẽ một con {{animal}} {{special}} đang {{action}} {{place}}, bức tranh này sẽ có màu sắc {{color}}, đúng không nào?"

const promptQuestions = [
    {
        key: "convat",
        question: "Cậu muốn vẻ con gì?",
        answers: [
            { message: "🐱 Mèo", correct: true, value: "cat" },
            { message: "🐶 Chó", correct: true, value: "dog" },
            { message: "🐰 Thỏ", correct: true, value: "rabbit" },
            { message: "🐻 Gấu", correct: true, value: "bear" },
        ],
        correctMessage: "Tớ hiểu rồi!",
    },
    {
        key: "danglamgi",
        question: "Con vật đang làm gì?",
        answers: [
            { message: "🏃 Chạy", correct: true, value: "running" },
            { message: "😴 Ngủ", correct: true, value: "sleeping" },
            { message: "🍎 Ăn", correct: true, value: "eating" },
            { message: "🎈 Chơi", correct: true, value: "playing" },
        ],
        correctMessage: "Tớ hiểu rồi!",
    },
    {
        key: "dangodau",
        question: "Con vật đang ở đâu?",
        answers: [
            { message: "🌳 Trong rừng", correct: true, value: "in a forest" },
            { message: "🏠 Trong nhà", correct: true, value: "in a house" },
            { message: "🌼 Ngoài đồng cỏ", correct: true, value: "in a grass field" },
            { message: "🏖 Trên bãi biển", correct: true, value: "on a beach" },
        ],
        correctMessage: "Tớ hiểu rồi!",
    },
    {
        key: "dacbiet",
        question: "Con vật có gì đặc biệt?",
        answers: [
            { message: "🎩 Đội mũ", correct: true, value: "wearing a hat" },
            { message: "🕶 Đeo kính", correct: true, value: "wearing glasses" },
            { message: "🎈 Cầm bóng bay", correct: true, value: "holding a balloon" },
            { message: "🦸 Mặc áo siêu nhân", correct: true, value: "wearing a superhero costume" },
        ],
        correctMessage: "Tớ hiểu rồi!",
    },
    {
        key: "mautranh",
        question: "Cậu muốn tranh có màu gì?",
        answers: [
            { message: "❤️ Màu đỏ", correct: true, value: "red" },
            { message: "💙 Màu xanh", correct: true, value: "blue" },
            { message: "💛 Màu vàng", correct: true, value: "yellow" },
            { message: "🌈 Nhiều màu", correct: true, value: "colorful" },
        ],
        correctMessage: "Tớ hiểu rồi!",
    },
]

function getValue(questions, index) {
    console.log(questions);
    return questions[index].answers[questions[index].answerIndex].value;
}

function getMessage(questions, index) {
    return questions[index].answers[questions[index].answerIndex].message.toLowerCase();
}

function genPrompt(questions) {
    return prompt
        .replace("{{animal}}", getValue(questions, 0))
        .replace("{{action}}", getValue(questions, 1))
        .replace("{{place}}", getValue(questions, 2))
        .replace("{{special}}", getValue(questions, 3))
        .replace("{{color}}", getValue(questions, 4))
}

function genString(questions) {
    return messageString
        .replace("{{animal}}", getMessage(questions, 0))
        .replace("{{action}}", getMessage(questions, 1))
        .replace("{{place}}", getMessage(questions, 2))
        .replace("{{special}}", getMessage(questions, 3))
        .replace("{{color}}", getMessage(questions, 4))
}

function MainState({ setNextState, setReset }) {
    const [questions, setQuestions] = useState([]);
    const [image, setImage] = useState(null);
    const [string, setString] = useState("");
    const [creatingImage, setCreatingImage] = useState(false);

    const generateImage = () => {
        setString(genString(questions));
        setCreatingImage(true);
        API.post("/AI/generate-image/", {
            prompt: genPrompt(questions)
        }, {
            responseType: "blob"
        })
            .then(res => {
                const imageUrl = URL.createObjectURL(res.data);
                setImage(imageUrl);
            })
            .catch(error => {
                console.log(error);
            })
    }

    const gauCreatingMessage = useMemo(() => [
        string,
        "Tớ vẽ xong ngay đây!"
    ], [string])

    return <div style={{
        position: "relative",
    }}>
        {creatingImage
            ? <GauLeft messages={gauCreatingMessage}>
                {image ? <div style={{
                    paddingTop: 80
                }}>
                    <div className='quiz-question'>
                        {string}
                    </div>
                    <Image src={image} />
                </div>
                : <Skeleton active />}
            </GauLeft>
            : <GauQuizzes
                messages={gauMessages}
                questions={questions}
                setQuestions={setQuestions}
                originQuestions={promptQuestions}
                onDone={{
                    button: "Tạo ảnh",
                    call: generateImage,
                }}
            />}

        <Button onClick={() => {
            setReset(reset => reset + 1);
        }} type="primary" style={{
            position: "absolute",
            left: 0,
            top: 0
        }}>
            <ReloadOutlined />
        </Button>
    </div>
}

export default function State5({ setNextState }) {
    const [reset, setReset] = useState(0);
    return <MainState key={reset} setNextState={setNextState} setReset={setReset} />
}
